<script>
    import { onMount } from "svelte";
    import { querystring, location, replace, push, pop } from "svelte-spa-router";
    import { Button, ButtonToolbar, Container, Col, Collapse, Fade, Form, Icon, Input, Navbar, Nav, NavLink, NavbarBrand, NavItem, NavbarToggler, Badge, Row, Table } from "sveltestrap";

    import helpers from "@/libs/helpers/index.js";
    import { storeConfig, storeLang, storeLocalesViews, storeModel, storeFile } from "@/stores/config.store";
    import { user } from "@/stores/app.store";
    import { storeFiles, storeUrlFiles, storeDeletedFiles, storeNewFiles } from "@/stores/files.store";
    import { storeThemeKeywords, storeInspireKeywords } from "@/stores/mdjs.store";

    $: isReady = localesView;

    let directories = {};
    let directoriesList = false;
    let search = "";
    let loadingDirectories = 0;
    let loadingFiles = [];
    let displayList = [];

    const view = "list";
    $: localesView = $storeLocalesViews[view];

    onMount(() => {
        // if (!$user.editor) {
        //     push("/?" + $querystring);
        // }
        const file = $storeConfig.views[view].locales[$storeLang];
        storeLocalesViews.setLocalesView(view, file);
        getDirectoriesList();
    });

    function getDirectoriesList() {
        // Get directories list
        loadingDirectories++;
        fetch($storeConfig.api.directories)
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                directoriesList = json.directories ? json.directories : [];
                loadingDirectories--;
                displayList = Array(directoriesList.length).fill(false);
                loadingFiles = Array(directoriesList.length).fill(0);
            })
            .catch(function (error) {
                console.log("Fetch error: " + error.message);
                loadingDirectories = 0;
            });
    }

    function getFiles(dirId, dirName) {
        // Get files
        loadingFiles[dirId]++;
        fetch($storeConfig.api.files + '&directory=' + dirName)
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                let files = json.files ? json.files : [];
                let directory = json.directory;
                loadingFiles[dirId]--;
                directories[directory] = checkFiles(directory, files);
            })
            .catch(function (error) {
                console.log("Fetch error: " + error.message);
                loadingFiles[dirId] = 0;
            });
    }

    function checkFiles(directory, files) {
        for (let f = 0, n = files.length; f < n; f++) {
            files[f].valid =
            files[f].file == directory + "/" + files[f].fileIdentifier + "/" + files[f].fileIdentifier + ".xml";
        }
        return files;
    }

    $: filteredDirectories = filterFiles(directories, search);

    function filterFiles(directories, search) {
        let directoriesCopy = JSON.parse(JSON.stringify(directories));
        for (let directory in directories) {
            directoriesCopy[directory] = [];
            for (let f = 0, n = directories[directory].length; f < n; f++) {
                let file = directories[directory][f];
                if (file) {
                    if (
                        !search ||
                        [file.filename, file.fileIdentifier, file.dataTitle]
                            .join(" ")
                            .toLocaleLowerCase()
                            .includes(search.toLocaleLowerCase())
                    ) {
                        directoriesCopy[directory].push(file);
                    }
                }
            }
        }
        return directoriesCopy;
    }

    function goBack() {
        pop();
    }

    function onDisplayDirectory(dirId, dirName) {
        displayList[dirId] = !displayList[dirId];
        if (displayList[dirId]) {
            getFiles(dirId, dirName); 
        }
    }

    function onDeleteFile(e, file) {
        e.preventDefault();
        var response = confirm(
            [
                "Voulez-vous vraiment supprimer le fichier '" +
                    file.filename +
                    ".xml' ainsi que le dossier '/" +
                    file.filename +
                    "' associé ?",
                "Fiche: " + file.dataTitle + " (" + file.fileIdentifier + ")",
            ].join("\n")
        );
        if (response == true) {
            var path = file.path.replace(/\\/g, "/");
            var url = $storeConfig.api.directories + "&directories=" + file.path;
            fetch(url, {
                method: "DELETE",
            })
                .then((response) => response.json())
                .then((json) => {
                    getData();
                });
        }
    }

    async function onLoadFile(e, file) {
        e.preventDefault();
        // Empty files stores
        $storeFiles = [];
        $storeUrlFiles = [];
        $storeDeletedFiles = [];
        $storeNewFiles = [];

        var url = $storeConfig.api.files + "&file=" + file.file;
        await storeFile.setFile(url, "url");
        push("/formdata?xml=" + file.file);
    }

    async function onViewFile(e, file) {
        e.preventDefault();
        var url = $storeConfig.api.files + "&file=" + file.file;
        await storeFile.setFile(url, "url");
        push("/view?xml=" + file.file);
    }

    function formatDate(date, format) {
        return helpers.formatDate(date, format);
    }

    //  Fonction en double dans FormData.svelte
    function onNewFile() {
        const model = $storeConfig.models.find((m) => m.code == "empty");
        storeModel.setModel(model);
        $storeThemeKeywords = [{}];
        $storeInspireKeywords = [{}];

        // Update 'xml' parameter in URL querystring
        let qs = helpers.updateQueryString($querystring, 'xml', '');
        push("/formdata?" + qs);
    }
</script>

{#if isReady}
    <Container>
        <Navbar color="white" light sticky="top" class="border-bottom m-0 p-0">
            <NavbarBrand href="#/">
                <Icon name="journal-richtext" class="" style="font-size: 2rem;" />
                mdEdit 3
            </NavbarBrand>

            <Nav class="d-flex w-50" navbar>
                <ButtonToolbar class="gap-1 d-flex">
                    <Button outline color="dark" class="d-print-none" on:click={goBack}>
                        <Icon name="caret-left" />
                        Retour
                    </Button>
                    <Form class="d-flex flex-grow-1">
                        <Input bind:value={search} class="w-100" type="search" id="searchInput" placeholder="Filtrer les fiches" />
                    </Form>
                    <Button
                        color="primary"
                        class=""
                        on:click={() => {
                            onNewFile();
                        }}
                    >
                        <Icon name="plus" />
                    </Button>
                </ButtonToolbar>
            </Nav>
        </Navbar>
    </Container>

    <Container class="mt-2">
        <div hidden={!loadingDirectories}>
            <div class="d-flex justify-content-center">
                <div class="m-5 text-center">
                    <div class="spinner-grow" role="status" />
                    <div>
                        <small class="text-muted"
                            >Chargement de la liste des catalogues...<br />Merci de patienter.</small
                        >
                    </div>
                </div>
            </div>
        </div>
        <div hidden={loadingDirectories}>
            
            {#if directoriesList.length}
                {#each directoriesList as dir, dirId}
                    <div class="my-4">
                        <Icon name="folder-fill" class="me-3" />
                        <strong>{dirId + 1} - Catalogue "{dir.name}"</strong> {dir.nb_files ? '({dir.nb_files} fiches)' : ''}
                        <ButtonToolbar class="float-end">
                            <Button
                                color="dark"
                                outline
                                class="mx-1"
                                on:click={() => onDisplayDirectory(dirId, dir.directory)}
                            >
                                <Icon name={displayList[dirId] ? "chevron-up" : "chevron-down"} />
                            </Button>
                        </ButtonToolbar>
                    </div>
                    <div class="mt-4 mb-5" hidden={!loadingFiles[dirId]}>
                        <div class="d-flex justify-content-center">
                            <div class="m-5 text-center">
                                <div class="spinner-grow" role="status" />
                                <div>
                                    <small class="text-muted"
                                        >Chargement des fiches...<br />Cela peut prendre un moment. Merci de patienter.</small
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 mb-5" hidden={loadingFiles[dirId]}>
                        <Fade isOpen={displayList[dirId]}>
                            {#if filteredDirectories[dir.directory] && filteredDirectories[dir.directory].length}
                                <Table hover>
                                    <thead>
                                        <tr class="d-flex">
                                            <th class="col-1 text-center" scope="col">#</th>
                                            <th class="col-7 text-center" scope="col">Fichier</th>
                                            <th class="col-2 text-center" scope="col">Modification</th>
                                            <th class="col-2 text-center" scope="col">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each filteredDirectories[dir.directory] as file, fileId}
                                            {#if file.fileIdentifier}
                                                <tr class="d-flex">
                                                    <td class="col-1 d-flex justify-content-center align-items-center">
                                                        {fileId + 1}
                                                    </td>
                                                    <td class="col-7">
                                                        {#if file.valid}
                                                            <a
                                                                href="#/"
                                                                class="link-dark h6"
                                                                title={file.filename}
                                                                on:click={(e) => {
                                                                    onLoadFile(e, file);
                                                                }}
                                                            >
                                                                <Icon
                                                                    name="file-earmark-code-fill"
                                                                    class="text-success"
                                                                />{#if file.draft}
                                                                    <Badge color="warning" class="mx-2">BROUILLON</Badge>
                                                                {:else}<Badge color="info" class="mx-2">PUBLIEE</Badge>
                                                                {/if}
                                                                {#if file.dataTitle}{file.dataTitle}
                                                                {:else}Titre non défini
                                                                {/if}
                                                            </a>
                                                        {:else}
                                                            <span title="Ce fichier ne peut pas être édité">
                                                                <Icon
                                                                    name="file-earmark-code-fill"
                                                                    class="text-danger"
                                                                />
                                                                {#if file.draft}
                                                                    <Badge color="warning" class="mx-2">BROUILLON</Badge>
                                                                {:else}<Badge color="info" class="mx-2">PUBLIEE</Badge>
                                                                {/if}
                                                                {#if file.dataTitle}{file.dataTitle}
                                                                {:else}Titre non défini
                                                                {/if}
                                                            </span>
                                                        {/if}
                                                        <div class="small font-weight-light" title={file.filename}>
                                                            Fichier: {file.basename}<br />
                                                            {#if file.fileIdentifier}
                                                                Identifiant: {file.fileIdentifier}
                                                            {/if}
                                                        </div>
                                                    </td>
                                                    <td class="col-2 d-flex justify-content-center align-items-center">
                                                        <!-- TODO: format date -->
                                                        {formatDate(new Date(file.mtime * 1000), "DD/MM/YYYY hh:mm:ss")}
                                                    </td>
                                                    <td
                                                        class="col-2 d-md-flex justify-content-center align-items-center"
                                                    >
                                                        {#if file.valid}
                                                            <Button
                                                                outline
                                                                size=""
                                                                color="danger"
                                                                class="me-2"
                                                                on:click={(e) => {
                                                                    onDeleteFile(e, file);
                                                                }}><Icon name="trash" /></Button
                                                            >
                                                            <Button
                                                                outline
                                                                size=""
                                                                color="primary"
                                                                class="me-2"
                                                                on:click={(e) => {
                                                                    onLoadFile(e, file);
                                                                }}><Icon name="pencil" /></Button
                                                            >
                                                        {/if}
                                                        <Button
                                                            outline
                                                            size=""
                                                            color="success"
                                                            class="me-2"
                                                            on:click={(e) => {
                                                                onViewFile(e, file);
                                                            }}><Icon name="eye" /></Button
                                                        >
                                                    </td>
                                                </tr>
                                            {/if}
                                        {/each}
                                    </tbody>
                                </Table>
                            {:else}
                                <Row>
                                    <Col>
                                        <p class="h5 text-center">
                                            Aucune fiche de métadonnées disponible dans ce répertoire
                                        </p>
                                    </Col>
                                </Row>
                            {/if}
                        </Fade>
                    </div>
                {/each}

            {:else}
                <Row>
                    <Col>
                        <p class="h5 text-center my-5">Aucun dossier ou fichier disponible</p>
                    </Col>
                </Row>
            {/if}

            <Row>
                <Col>
                    <ButtonToolbar class="float-end mb-5">
                        <Button outline color="dark" class="me-3" on:click={goBack}>
                            <Icon name="caret-left" />
                            Retour
                        </Button>
                    </ButtonToolbar>
                </Col>
            </Row>
        </div>
    </Container>
{/if}
